<template>
  <div class="small">
    <line-chart :chart-data="datacollection" />
    <button @click="fillData()">
      Randomize
    </button>
    <br>
    <button @click="test()">
      test
    </button>
  </div>
</template>

<script>
/* eslint-disable */
  import LineChart from './LineChart.js'

  export default {
    components: {
      LineChart
    },
    data () {
      return {
        datacollection: null
      }
    },
    mounted () {
      this.fillData()
    },
    methods: {
      fillData () {
        this.datacollection = {
          labels: ['aaa', 'aas'],
          datasets: [
            {
              label: 'Data One',
              backgroundColor: '#f87979',
              data: [this.getRandomInt(), this.getRandomInt()],
            }, {
              label: 'Data One',
              backgroundColor: '#f179',
              data: [this.getRandomInt(), this.getRandomInt()],
            },
          ],
        }
      },
      getRandomInt () {
        return Math.floor(Math.random() * (50)) + 5
      },
      test () {
        getCSV()
      },
    },
  }
  function getCSV(){
    var req = new XMLHttpRequest() // HTTPでファイルを読み込むためのXMLHttpRrequestオブジェクトを生成
    req.open("get", "sample.csv", true) // アクセスするファイルを指定
    req.send(null) // HTTPリクエストの発行
	
    // レスポンスが返ってきたらconvertCSVtoArray()を呼ぶ	
    req.onload = function(){
	    convertCSVtoArray(req.responseText) // 渡されるのは読み込んだCSVデータ
    }
  }
  
  // 読み込んだCSVデータを二次元配列に変換する関数convertCSVtoArray()の定義
  function convertCSVtoArray(str){ // 読み込んだCSVデータが文字列として渡される
      var result = [] // 最終的な二次元配列を入れるための配列
      var tmp = str.split("\n") // 改行を区切り文字として行を要素とした配列を生成
  
      // 各行ごとにカンマで区切った文字列を要素とした二次元配列を生成
      for(var i=0; i<tmp.length; ++i) {
          result[i] = tmp[i].split(',')
      }
  
      alert(result[1][2]) // 300yen
  }
</script>

<style>
  .small {
    max-width: 600px;
    margin:  150px auto;
  }
</style>